const referencedProps = {
  cx: 0,
  cy: 0,
  // Distance to the start node
  g: Infinity,
  h: Infinity,
  f: Infinity,
  visited: false,
  parent: null,
  closed: false
};

export const allNodesInfo = dataArr => {
  let result = [];
  dataArr.forEach(item => {
    result[item.id] = {
      id: item.id,
      ...referencedProps,
      visited: item.noRedirect,
      cx: item.cx,
      cy: item.cy
    }; 
  });
  return result;
};

export default function matrixBuilder (dataArr, eleLength) {
  const arrayModel = new Array(eleLength);

  let result = [...arrayModel].fill([...arrayModel].fill(Infinity));
  dataArr.forEach(item => {
    const xAxis = item[0].id;
    const yAxis = item[1].id;
    const distance = item[2];
    let newXAxis = [...result[xAxis]];
    newXAxis.splice(yAxis, 1, distance);
    result[xAxis] = newXAxis;

    const newXAxis2 = [...result[yAxis]];
    newXAxis2.splice(xAxis, 1, distance);
    result[yAxis] = newXAxis2;

  });
  return result;
};